import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const MostFollowingWinsIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      fill={theme.palette.text.primary}
      height={props.width} width={props.width} viewBox='0 0 180 80' xmlns='http://www.w3.org/2000/svg'
    >
      <g stroke='black' stroke-width='2' fill='none'>
        <circle cx='40' cy='50' r='14' />
        <circle cx='40' cy='50' r='11' />
        <path d='M36 35 C35 28, 45 28, 44 35' />
        <path d='M40 35 L35 15 M40 35 L45 15' />
        <text x='40' y='54' text-anchor='middle' font-size='9' fill='black' font-family='sans-serif'>1</text>
        <circle cx='90' cy='50' r='14' />
        <circle cx='90' cy='50' r='11' />
        <path d='M86 35 C85 28, 95 28, 94 35' />
        <path d='M90 35 L85 15 M90 35 L95 15' />
        <text x='90' y='54' text-anchor='middle' font-size='9' fill='black' font-family='sans-serif'>1</text>
        <circle cx='140' cy='50' r='14' />
        <circle cx='140' cy='50' r='11' />
        <path d='M136 35 C135 28, 145 28, 144 35' />
        <path d='M140 35 L135 15 M140 35 L145 15' />
        <text x='140' y='54' text-anchor='middle' font-size='9' fill='black' font-family='sans-serif'>1</text>
      </g>
    </svg>
  )
}
export default MostFollowingWinsIcon
